// rounded outlined inputs shared by the text-like crud fields
export const textFieldSx = {
  "& .MuiOutlinedInput-root, & .MuiInputBase-root": {
    borderRadius: "0.75rem",
  },
  "& .MuiOutlinedInput-input": {
    padding: "1rem",
  },
};

export const textAreaFieldStyle = (hasError: boolean) => ({
  boxSizing: "border-box" as const,
  resize: "vertical" as const,
  whiteSpace: "pre" as const,
  ...(hasError ? { borderColor: "var(--error)" } : {}),
});
